<div class="tiny-promo">
  <h2>Promo commissions</h2>
  <p *ngIf="loadError" class="tiny-promo__error" role="status">Commissions could not be loaded.</p>
  <p *ngIf="loaded && !loadError && commissions.length === 0" role="status">No commissions.</p>

  <section class="tiny-promo__card" *ngFor="let row of commissions">
    <p><strong>Commission ID</strong>: {{ row.id }}</p>
    <p *ngIf="row.promoCode || row.program">Promo code: {{ row.promoCode || '—' }} · {{ row.program || 'STANDARD' }}</p>
    <p>{{ row.promoterEmail || 'No promoter' }}</p>
    <p>{{ row.hubId }} · {{ row.promotionId }}</p>
    <p>{{ row.requestId }}</p>
    <p>Paid amount: {{ row.customerPaidAmount | currency:(row.currency || 'DOP') }}</p>
    <p>Comisión total: {{ row.promoterCommissionAmount | currency:(row.currency || 'DOP') }}</p>
    <p>TinyPromo fee: {{ row.tinyPromoFeeAmount | currency:(row.currency || 'DOP') }} ({{ row.tinyPromoFeeRate }}%)</p>
    <p>Commission status: {{ statusLabel(row.status) }}</p>
    <p *ngIf="row.earnedAt">{{ row.earnedAt | date:'medium' }}</p>
    <div *ngIf="canChangeStatus" class="tiny-promo__actions">
      <button *ngIf="row.status === 'PENDING'" pButton type="button" class="p-button-outlined" label="Verify" (click)="setStatus(row, 'VERIFIED')"></button>
      <button *ngIf="row.status === 'VERIFIED'" pButton type="button" class="p-button-outlined" label="Mark payable" (click)="setStatus(row, 'PAYABLE')"></button>
      <button *ngIf="row.status === 'PAYABLE'" pButton type="button" class="p-button-outlined" label="Mark paid" (click)="setStatus(row, 'PAID')"></button>
      <button *ngIf="row.status !== 'CANCELLED'" pButton type="button" class="p-button-text" label="Cancel commission" (click)="setStatus(row, 'CANCELLED')"></button>
    </div>
  </section>
</div>
